export const Instagram = "https://www.instagram.com/crisdulabs/";
export const Facebook = "https://pt-br.facebook.com/";
export const Tiktok = "https://www.tiktok.com/pt-BR/";
export const Youtube = "https://www.youtube.com/?hl=pt-br";
export const Twitter = "https://twitter.com/";
export const Linkedin = "https://br.linkedin.com/";
